/**
 * Collapse the document's <title> elements down to a single one.
 *
 * The SPA shell (apps/client/index.html) sets a default title with a bootstrap
 * `<script>document.title = …</script>` that runs during initial parse. That
 * setter creates a phantom <title> element. React 19 then renders this page's
 * own <title> but does NOT remove the phantom (its head-hoisting doesn't dedupe
 * against pre-existing head elements — the same reason canonical/alternate links
 * are de-duplicated by hand in PublicPageSeo). The result is two <title> tags in
 * the prerendered/hydrated head.
 *
 * Keep the element whose text matches this page's `title` (falling back to the
 * first <title> so we never strip the head bare), and remove the rest. Order-
 * independent on purpose: which copy is "the phantom" depends on React internals.
 */
export function dedupeTitleTags(doc: Document, title: string): void {
  const titles = Array.from(doc.querySelectorAll('title'))
  if (titles.length < 2) return

  const keeper = titles.find((el) => el.textContent === title) ?? titles[0]
  for (const el of titles) {
    if (el !== keeper) el.remove()
  }
}
